import useHttpPost from "./useHttpPost";

function usePostCostCentre(target) {
  return useHttpPost("costcentre", "post", {}, target);
}

export default usePostCostCentre;
